import { NuxtAxiosInstance } from '@nuxtjs/axios';
import { IDatasetsImportPayload } from '../models/datasets';

export default ($axios: NuxtAxiosInstance) => ({
  import(payload: IDatasetsImportPayload) {
    return $axios.post('/api/v1/datasets/import', payload);
  },
});
